import React, { Component } from 'react';
import $ from 'jquery';
import NavMenu from '../../components/navMenu/navMenu';
import HeaderMenu from '../../components/headerMenu/headerMenu';
import { requests, getToken, loadZhuKeToken, getLoginShopInfo, messageShow } from '../../utils/http';
import { Pagination, Select, Input, Button, Message } from 'element-react';
import MyLoading from '../../components/showLoading/showLoading';
import NewUserGuide from '../../components/newUserGuide/index.jsx';
import ShowModal from '../../components/showModal/index.jsx';
import ShowDrawer from '../../components/showDrawer/index.jsx';
import '../../assets/css/common.less';
import './index.less';

class officialReturnWarehouse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            loadingTitle: '加载中...',
            setGuide: false,
            selectShopId: "",
            selectShopName: "",
            queryType: 0,
            queryKeyword: "",
            pageIndex: 1,
            pageSize: 10,
            total: 0,
            wareHouseList: [],
            supplierPageList: [],
            sPageIndex: 1,
            sPageSize: 10,
            sTotal: 0,
            selectWareHouseList: [],
            isShowModalSyncShop: false,
            syncShopData: {
                Code: "",
                Name: "",
                ContactorName: "",
                ContactorPhone: "",
                DetailAddress: ""
            },
            isShowDrawerRelated: false,
            relatedData: {
                Code: "",
                Name: "",
                ContactorName: "",
                ContactorPhone: "",
                DetailAddress: ""
            },
            isShowRelatedSupplier: false,
            relatedSupplierData: {
                Code: "",
                Name: "",
                ContactorName: "",
                ContactorPhone: "",
                DetailAddress: ""
            },
            selectSupplierList: [],
        };
    }

    componentDidMount() {
        var zhukeToken = getToken();
        var that = this;
        if (zhukeToken != "")
            that.loadData();
        else {
            setTimeout(() => {
                var zhukeTokenTwo = getToken();
                if (zhukeTokenTwo == "") {
                    var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
                    if (hasZhukeLoginShopTokens != null && hasZhukeLoginShopTokens != "" && hasZhukeLoginShopTokens != undefined) {
                        loadZhuKeToken(hasZhukeLoginShopTokens);
                        setTimeout(() => {
                            var zhukeTokenThree = getToken();
                            if (zhukeTokenThree != "")
                                that.loadData();
                            else
                                that.setState({ isShowWarn: true });
                        }, 500);
                    } else
                        that.setState({ isShowWarn: true });
                } else
                    that.loadData();
            }, 500);
        }
    }

    changeNav = (name) => {
        this.props.history.replace(name)
    }

    loadData = () => {
        var shopInfo = getLoginShopInfo();
        const setGuide = localStorage.getItem("SetOfficialReturnWarehouseGuide-" + shopInfo.loginShopId);
        var that = this;
        that.setState({
            isLoading: true,
            selectShopId: shopInfo.loginShopId,
            selectShopName: shopInfo.loginShopName,
            setGuide: setGuide ? true : false
        }, () => {
            that.syncAlibabaWareHouse();
        })
    }

    // 获取官方仓列表数据
    getWareHousePageList = () => {
        $("#allCheck_id_Below").prop("checked", false);//上面的按钮点击，下面的全选跟着变化
        $("#allCheck_id_Above").prop("checked", false);//下面的按钮点击，上面的全选跟着变化

        const data = {
            QueryType: this.state.queryType,
            QueryKeyword: $("#queryKeyword").val(),
            PageIndex: this.state.pageIndex,
            PageSize: this.state.pageSize,
            ShopId: this.state.selectShopId
        };

        this.setState({ isLoading: true, loadingTitle: "加载中...", selectWareHouseList: [] });

        var that = this;
        requests({
            url: "/AlibabaWareHouse/GetWareHousePageList",
            data: data,
            success: function (res) {
                that.setState({ isLoading: false });
                if (res.Success) {
                    var listData = res.Data.Data || [];
                    var totalCount = res.Data.TotalCount;
                    that.setState({ wareHouseList: listData, total: totalCount });
                } else {
                    Message({
                        showClose: true,
                        message: "获取官方仓错误：" + res.Message,
                        type: 'error'
                    });
                }
            },
            fail: (err) => { }
        });
    }

    // 查询
    queryButton = (isQuery) => {
        if (isQuery) {  //为true 时为搜索调用  current恢复第1页
            this.setState({ pageIndex: 1 }, () => {
                this.getWareHousePageList();
            })
        } else {     //为切换页码时调用
            this.getWareHousePageList();
        }
    }

    // 同步官方仓
    syncAlibabaWareHouse = (isSync) => {
        var that = this;
        if (isSync) {
            that.setState({ isLoading: true, loadingTitle: "同步中..." });
        }
        requests({
            url: "/AlibabaWareHouse/SyncAlibabaWareHouse",
            success: function (res) {
                if (res.Success) {
                    if (isSync) {
                        that.setState({ isLoading: false });
                        Message({ showClose: true, message: "同步成功", type: 'success' });
                    }
                    that.queryButton(true);
                } else {
                    that.setState({ isLoading: false });
                    Message({
                        showClose: true,
                        message: "同步失败，请先前往1688官方仓退货中开通服务才可同步官方仓",
                        type: 'error'
                    });
                }
            },
            fail: (err) => {
                that.setState({ isLoading: false });
            }
        });
    }

    // 切换分页-当前页
    changeCurrent = (type, pageIndex) => {
        if (type == 3 || type == 2) {
            this.setState({
                sPageIndex: pageIndex
            }, () => {
                if (type == 3) {
                    this.openRelatedSupplierV2(this.state.relatedSupplierData, true);
                } else {
                    this.openRelatedSupplier(this.state.relatedData, true);
                }
            })
        } else {
            this.setState({
                pageIndex
            }, () => {
                this.queryButton();
            })
        }
    }

    // 切换分页-条数
    changePageSize = (type, size) => {
        if (type == 3 || type == 2) {
            this.setState({
                sPageSize: size,
                sPageIndex: 1,
            }, () => {
                if (type == 3) {
                    this.openRelatedSupplierV2(this.state.relatedSupplierData, true);
                } else {
                    this.openRelatedSupplier(this.state.relatedData, true);
                }
            })
        } else {
            this.setState({
                pageSize: size,
                pageIndex: 1,
            }, () => {
                this.queryButton();
            })
        }
    }

    //全选
    allCheckbox(types, some) {
        if (some == "id") {
            var isCheck = false;

            if (types == "above")
                isCheck = $("#allCheck_id_Above").prop("checked");//上面的按钮
            else
                isCheck = $("#allCheck_id_Below").prop("checked");//下面的按钮

            var wareHouseList = [];
            var consignWareHouseList = this.state.wareHouseList;

            if (isCheck) {
                consignWareHouseList.forEach(x => x.checked = true)
                wareHouseList = consignWareHouseList.map(x => x.Code)
            } else {
                consignWareHouseList.forEach(x => x.checked = false)
            }

            $("#allCheck_id_Below").prop("checked", isCheck);//上面的按钮点击，下面的全选跟着变化
            $("#allCheck_id_Above").prop("checked", isCheck);//下面的按钮点击，上面的全选跟着变化
            this.setState({ selectWareHouseList: wareHouseList });
        } else {
            var isCheck = false;

            if (types == "above")
                isCheck = $("#allCheck_supplier_Above").prop("checked");//上面的按钮
            else
                isCheck = $("#allCheck_supplier_Below").prop("checked");//下面的按钮

            var supplierList = [];
            var consignSupplierList = this.state.supplierPageList.filter(function (item) {
                return item.IsReation == false
            });

            if (isCheck) {
                consignSupplierList.forEach(x => x.checked = true);
                supplierList = consignSupplierList.map(x => x.SupplierLoginId)
            } else {
                consignSupplierList.forEach(x => x.checked = false)
            }

            $("#allCheck_supplier_Below").prop("checked", isCheck);//上面的按钮点击，下面的全选跟着变化
            $("#allCheck_supplier_Above").prop("checked", isCheck);//下面的按钮点击，上面的全选跟着变化
            this.setState({ selectSupplierList: supplierList });
        }
    }

    //勾选地址事件
    wareHouseCheckbox(item) {
        var list = [];
        item.checked = !item.checked;
        this.state.wareHouseList.forEach(x => {
            if (x.checked) list.push(x.Code);
        })
        this.setState({ selectWareHouseList: list });
    }

    // 勾选供应商
    supplierCheckbox(item) {
        var list = [];
        item.checked = !item.checked;
        this.state.supplierPageList.forEach(x => {
            if (x.checked) list.push(x.SupplierLoginId);
        })
        this.setState({ selectSupplierList: list });
    }

    // 关联供应商-操作
    batchRelationSupplier() {
        var selectSupplierList = this.state.selectSupplierList;

        if (selectSupplierList.length == 0) {
            messageShow("请选择供应商！", 'info');
            return;
        }

        this.setState({ isLoading: true, loadingTitle: "关联中..." });
        var that = this;

        const data = {
            AlibabaWareHouseCode: this.state.relatedSupplierData.Code,
            SupplierLoginIds: selectSupplierList
        };

        requests({
            url: "/AlibabaWareHouse/AlibabaWareHouseRelationSupplier",
            data: data,
            success: function (res) {
                that.setState({ isLoading: false });
                if (res.Success) {
                    Message({
                        showClose: true,
                        message: "关联成功",
                        type: 'success'
                    });
                    that.setState({ selectSupplierList: [] });
                    that.cancelSupplierDrawer();
                    that.getWareHousePageList();
                } else {
                    Message({
                        showClose: true,
                        message: "同步至店铺错误：" + res.Message,
                        type: 'error'
                    });
                }
            },
            fail: (err) => { }
        });

    }

    // 批量同步至店铺
    batchSyncToShop() {
        var list = this.state.wareHouseList;
        var selectWareHouseList = this.state.selectWareHouseList;

        if (selectWareHouseList.length == 0) {
            messageShow("请选择地址！", 'info');
            return;
        }

        // 只勾选单个地址
        if (selectWareHouseList.length == 1) {

            const fData = list.find(function (item) {
                return item.Code == selectWareHouseList[0];
            });

            if (fData) {
                this.openSyncToShop(fData)
            }
        }
        else if (selectWareHouseList.length > 1) {
            this.setState({
                isShowModalSyncShop: true
            });
        }
    }

    // 同步至店铺 (单店铺)
    openSyncToShop(item) {
        this.setState({
            isShowModalSyncShop: true,
            syncShopData: item
        });
    }

    // 查看已关联供应商
    openRelatedSupplier(item, isUnding, isSet) {
        this.setState({ isLoading: true, loadingTitle: "加载中...", sPageIndex: isSet ? 1 : this.state.sPageIndex });
        const data = {
            AlibabaWareHouseCode: item.Code,
            SupplierLoginId: $("#supplierLoginId").val(),
            PageIndex: isSet ? 1 : this.state.sPageIndex,
            PageSize: this.state.sPageSize,
            IsSelectRelationSupplier: true
        };
        var that = this;

        requests({
            url: "/AlibabaWareHouse/GetWareHouseRelationSupplierPageList",
            data: data,
            success: function (res) {
                that.setState({ isLoading: false });
                if (res.Success) {
                    var listData = res.Data.Data || [];
                    var totalCount = res.Data.TotalCount;
                    if (!isUnding) {
                        that.setState({
                            isShowDrawerRelated: true,
                            relatedData: item
                        });
                    }
                    that.setState({
                        supplierPageList: listData,
                        sTotal: totalCount
                    });
                } else {
                    Message({
                        showClose: true,
                        message: "获取官方仓供应商列表错误：" + res.Message,
                        type: 'error'
                    });

                }
            },
            fail: (err) => { }
        });
    }

    // 关联供应商
    openRelatedSupplierV2(item, isQuery, isSet) {
        $("#allCheck_supplier_Below").prop("checked", false);
        $("#allCheck_supplier_Above").prop("checked", false);

        this.setState({ isLoading: true, selectSupplierList: [], loadingTitle: "加载中...", sPageIndex: isSet ? 1 : this.state.sPageIndex });
        const data = {
            AlibabaWareHouseCode: item.Code,
            SupplierLoginId: $("#supplierLoginId2").val(),
            PageIndex: isSet ? 1 : this.state.sPageIndex,
            PageSize: this.state.sPageSize,
            IsSelectRelationSupplier: false
        };

        var that = this;
        requests({
            url: "/AlibabaWareHouse/GetWareHouseRelationSupplierPageList",
            data: data,
            success: function (res) {
                that.setState({ isLoading: false });
                if (res.Success) {
                    var listData = res.Data.Data || [];
                    var totalCount = res.Data.TotalCount;

                    if (!isQuery) {
                        that.setState({
                            isShowRelatedSupplier: true,
                            relatedSupplierData: item
                        });
                    }
                    that.setState({
                        supplierPageList: listData,
                        sTotal: totalCount
                    });
                } else {
                    Message({
                        showClose: true,
                        message: "查询官方仓供应商列表错误：" + res.Message,
                        type: 'error'
                    });

                }
            },
            fail: (err) => { }
        });
    }

    // 同步至店铺--操作
    handleSyncToShop() {
        this.setState({ isLoading: true, loadingTitle: "同步中..." });
        var that = this;

        const { selectWareHouseList, syncShopData } = this.state;
        const data = {
            AlibabaWareHouseCodes: syncShopData.Code ? [syncShopData.Code] : selectWareHouseList,
            ShopIds: [this.state.selectShopId - 0]
        };

        requests({
            url: "/AlibabaWareHouse/SyncAlibabaWareHouseToPlatform",
            data: data,
            success: function (res) {
                that.setState({ isLoading: false });
                if (res.Success) {
                    that.getWareHousePageList();
                    that.setState({ selectWareHouseList: [] });
                    Message({
                        showClose: true,
                        message: "同步成功",
                        type: 'success'
                    });
                    that.cancelDailog();
                } else {
                    Message({
                        showClose: true,
                        message: "同步至店铺错误：" + res.Message,
                        type: 'error'
                    });
                }
            },
            fail: (err) => { }
        });
    }

    // 关闭同步至店铺弹窗
    cancelDailog = () => {
        this.setState({
            isShowModalSyncShop: false,
            syncShopData: {
                Code: "",
                Name: "",
                ContactorName: "",
                ContactorPhone: "",
                DetailAddress: ""
            }
        });
    }

    // 关闭-已关联供应商
    cancelDrawer = () => {
        this.setState({
            isShowDrawerRelated: false,
            sPageIndex: 1,
            sPageSize: 10,
            supplierPageList: [],
            relatedData: {
                Code: "",
                Name: "",
                ContactorName: "",
                ContactorPhone: "",
                DetailAddress: ""
            }
        });
    }

    // 关闭-关联供应商
    cancelSupplierDrawer = () => {
        this.setState({
            isShowRelatedSupplier: false,
            sPageIndex: 1,
            sPageSize: 10,
            supplierPageList: [],
            relatedSupplierData: {
                Code: "",
                Name: "",
                ContactorName: "",
                ContactorPhone: "",
                DetailAddress: ""
            }
        });
    }

    // 指引-不再提示
    onCloseGuide() {
        localStorage.setItem("SetOfficialReturnWarehouseGuide-" + this.state.selectShopId, 1);
        this.setState({
            setGuide: true
        });
    }

    // 切换下拉框选项
    changeSelect = (name, value) => {
        this.setState({
            [name]: value
        })
    }

    // 解绑供应商
    onUnbindSupplier = (SupplierLoginId, Code, type) => {
        const data = {
            SupplierLoginIds: [SupplierLoginId],
            AlibabaWareHouseCode: Code
        };
        var that = this;
        that.setState({ isLoading: true, loadingTitle: "解绑中..." });

        requests({
            url: "/AlibabaWareHouse/AlibabaWareHouseUnRelationSupplier",
            data: data,
            success: function (res) {
                that.setState({ isLoading: false });
                if (res.Success) {
                    var item = {
                        Code: Code
                    }

                    if (type == 1) {
                        that.openRelatedSupplier(item, true);
                    } else {
                        that.openRelatedSupplierV2(item, true);
                    }
                    Message({
                        showClose: true,
                        message: "解绑成功",
                        type: 'success'
                    });
                } else {
                    Message({
                        showClose: true,
                        message: res.Message,
                        type: 'error'
                    });
                }
            }
        });
    }

    render() {

        const { setGuide, selectShopId, queryType, wareHouseList, total, pageSize, pageIndex, isShowModalSyncShop, selectShopName,
            syncShopData, isShowDrawerRelated, relatedData, supplierPageList, sTotal, sPageSize, sPageIndex, isShowRelatedSupplier,
            relatedSupplierData, selectSupplierList, selectWareHouseList, isLoading, loadingTitle
        } = this.state;

        return (
            <div className='wrap'>
                <HeaderMenu />
                <main>
                    <div className='wrap-left scroll-x' >
                        <NavMenu changeNav={this.changeNav} defaultActive={"/officialReturnWarehouse"} />
                    </div>
                    <div className="wrap-right">
                        <div className='official_return_arehouse-wrap'>
                            {
                                setGuide == false && selectShopId ? <div className='ora_guide'>
                                    <div className='ora_guide-box'>
                                        <div className='ora_guide-item'>
                                            <div className='ora_guide-title'>1.开通1688官方仓退货服务</div>
                                            <div style={{ padding: '14px 0px 6px 40px' }}>开通1688官方仓退货服务</div>
                                            <a href="https://air.1688.com/app/channel-fe/distribution-work/sales_return_warehouse.html#/home" target="_blank">{'立即前往>'}</a>
                                        </div>
                                        <div className='ora_guide_arrow'>
                                            <span className='ora_guide_arrow-line'></span>
                                            <span className='ora_guide_arrow-triangle'></span>
                                        </div>
                                        <div className='ora_guide-item'>
                                            <div className='ora_guide-title'>2.同步官方仓</div>
                                            <div style={{ paddingTop: '14px', paddingLeft: '44px' }}>点击同步官方仓按钮，获取1688官方仓地址</div>
                                        </div>
                                        <div className='ora_guide_arrow'>
                                            <span className='ora_guide_arrow-line'></span>
                                            <span className='ora_guide_arrow-triangle'></span>
                                        </div>
                                        <div className='ora_guide-item'>
                                            <div className='ora_guide-title'>3.关联供应商</div>
                                            <div style={{ paddingTop: '14px', paddingLeft: '12px', paddingRight: '12px' }}>关联供应商，指定供应商的官方仓售后单会自动向供应商发起售后申请</div>
                                        </div>
                                        <div className='ora_guide_arrow'>
                                            <span className='ora_guide_arrow-line'></span>
                                            <span className='ora_guide_arrow-triangle'></span>
                                        </div>
                                        <div className='ora_guide-item'>
                                            <div className='ora_guide-title'>4.同步至店铺</div>
                                            <div style={{ paddingTop: '14px', paddingLeft: '12px', paddingRight: '12px' }}>发货前绑定供应商并同步官方仓地址至店铺，通过铺货代发发货，官方仓售后单同意售后，平台会将该退货地址展示给买家，买家按照该地址退回商品</div>
                                        </div>
                                    </div>
                                    <div className='no_tip-btn' onClick={() => this.onCloseGuide()}>
                                        不再提示
                                    </div>
                                </div> : null
                            }
                            <div className='searchWrap mywrap' style={{ marginTop: '12px' }}>
                                <Select onChange={this.changeSelect.bind(this, "queryType")} value={queryType} style={{ width: "120px", marginRight: "6px" }}>
                                    <Select.Option key={0} label="仓库名称" value={0} />
                                    <Select.Option key={1} label="收件人" value={1} />
                                    <Select.Option key={2} label="联系电话" value={2} />
                                    <Select.Option key={3} label="详细地址" value={3} />
                                </Select>
                                <input style={{ width: "200px", marginRight: "20px" }} type="text" id="queryKeyword" placeholder="输入值" />
                                <Button type="primary" style={{ marginRight: "4px" }} onClick={() => this.queryButton(true)}>查询</Button>
                                <Button type="primary" onClick={() => this.syncAlibabaWareHouse(true)}>同步官方仓</Button>
                            </div>
                            <div className='mywrap'>
                                <table className="table-style01">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "130px" }}>
                                                <input type="checkbox" id="allCheck_id_Above" onClick={() => this.allCheckbox("above", "id")} />
                                            </th>
                                            <th style={{ width: "150px" }}>仓库名称</th>
                                            <th style={{ width: "150px" }}>收货信息</th>
                                            <th style={{ width: "150px" }}>同步店铺状态</th>
                                            <th style={{ width: "150px" }}>已关联供应商</th>
                                            <th style={{ width: "150px" }}>操作</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* 无数据*/}
                                        {
                                            wareHouseList.length == 0 ?
                                                <tr>
                                                    <td className="noneData" colSpan="20">
                                                        <div className="noneData-wrap">
                                                            <i className="iconfont icon-wushuju"></i>
                                                            <span className="noneData-title">暂无数据！</span>
                                                        </div>
                                                    </td>
                                                </tr> : null
                                        }

                                        {
                                            wareHouseList.map((item) =>
                                                <tr key={item.Code}>
                                                    <td>
                                                        {
                                                            item.checked ?
                                                                <input type="checkbox" key={item.Code} checked onClick={() => this.wareHouseCheckbox(item)} /> :
                                                                <input type="checkbox" key={item.Code} onClick={() => this.wareHouseCheckbox(item)} />
                                                        }
                                                    </td>
                                                    <td>
                                                        {item.Name}
                                                    </td>
                                                    <td>
                                                        <div>
                                                            <div><span>收件人：</span>{item.ContactorName}</div>
                                                            <div><span>电话：</span>{item.ContactorPhone}</div>
                                                            <div style={{ whiteSpace: 'nowrap' }}><span>地址：</span>{item.ProvinceName} {item.CityName} {item.AreaName} {item.TownName} {item.DetailAddress}</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {item.ShopCount > 0 && item.ShopIds && item.ShopIds.length > 0 && item.ShopIds.includes(selectShopId) ? "已同步" : "未同步"}
                                                    </td>
                                                    <td>
                                                        {
                                                            item.SupplierCount > 0 ? <span onClick={() => this.openRelatedSupplier(item)} style={{ cursor: 'pointer', color: '#169bd5' }}>{item.SupplierCount}</span>
                                                                : <span>0</span>
                                                        }
                                                    </td>
                                                    <td>
                                                        <div>
                                                            <span onClick={() => this.openSyncToShop(item)} style={{ cursor: 'pointer', color: '#169bd5', marginRight: "12px" }}>同步至店铺</span>
                                                            <span onClick={() => this.openRelatedSupplierV2(item)} style={{ cursor: 'pointer', color: '#169bd5' }}>关联供应商</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                                <div className='paginationwrap' style={{ "marginBottom": "30px" }}>
                                    <Pagination
                                        onCurrentChange={this.changeCurrent.bind(this, 1)}
                                        onSizeChange={this.changePageSize.bind(this, 1)}
                                        layout="total,sizes,prev, pager, next"
                                        total={total}
                                        pageSize={pageSize}
                                        currentPage={pageIndex}
                                        pageSizes={[10, 30, 50]}
                                    />
                                </div>
                            </div>

                            <ShowModal showModal={isShowModalSyncShop} cancelDailog={this.cancelDailog} hideBtn={true} titleName={'同步至店铺'} showTitleClose={true} >
                                <div>
                                    <div style={{
                                        color: '#ffad3d', fontSize: "12px", backgroundColor: '#fef1dd',
                                        padding: '6px 12px',
                                        borderRadius: '6px',
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}>
                                        <span>目前仅支持同步至抖音！</span>
                                        <span>同步成功后请勿擅自在店铺后台修改官方仓地址，擅自修改会导致平台展示退货地址错误，从而造成买家寄错地址，且官方仓售后单标记为地址异常</span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', marginRight: '28px', whiteSpace: 'nowrap' }}>
                                            <span>同步店铺：</span>
                                        </div>
                                        <Input style={{ width: "100%" }} disabled value={selectShopName} />
                                    </div>
                                    {
                                        syncShopData.ContactorName ? <div>
                                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', marginRight: '28px', whiteSpace: 'nowrap' }}>
                                                    <span>仓库名称：</span>
                                                </div>
                                                <Input style={{ width: "100%" }} disabled value={syncShopData.Name} />
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', marginRight: '16px', whiteSpace: 'nowrap' }}>
                                                    <span>仓库收件人：</span>
                                                </div>
                                                <Input style={{ width: "100%" }} disabled value={syncShopData.ContactorName} />
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', marginRight: '4px', whiteSpace: 'nowrap' }}>
                                                    <span>仓库联系电话：</span>
                                                </div>
                                                <Input style={{ width: "100%" }} disabled value={syncShopData.ContactorPhone} />
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', marginRight: '28px', whiteSpace: 'nowrap' }}>
                                                    <span>仓库地址：</span>
                                                </div>
                                                <Input style={{ width: "100%" }} disabled value={`${syncShopData.ProvinceName} ${syncShopData.CityName} ${syncShopData.AreaName} ${syncShopData.TownName} ${syncShopData.DetailAddress}`} />
                                            </div>
                                        </div> : null
                                    }
                                </div>
                                <div className="showModalWrap-box-commonfooter" style={{ marginTop: '10px' }}>
                                    <span className="showModalWrap-box-footer-btn" onClick={() => this.handleSyncToShop()}>同步至店铺</span>
                                </div>
                            </ShowModal>

                            <ShowDrawer showModal={isShowDrawerRelated} cancelDailog={this.cancelDrawer} hideBtn={true} titleName={'已关联供应商'} showTitleClose={true}>
                                <div style={{ padding: '10px 24px', backgroundColor: "#f2f4f6", borderRadius: '6px', marginBottom: '8px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
                                        <span>仓库：</span>
                                        <span> {relatedData.Name}</span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
                                        <span>收件人：</span>
                                        <span> {relatedData.ContactorName}</span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
                                        <span>电话：</span>
                                        <span> {relatedData.ContactorPhone}</span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <span>地址：</span>
                                        <span> {`${relatedData.ProvinceName} ${relatedData.CityName} ${relatedData.AreaName} ${relatedData.TownName} ${relatedData.DetailAddress}`}</span>
                                    </div>
                                </div>
                                <div>
                                    <input style={{ width: "200px", marginRight: "12px" }} type="text" id="supplierLoginId" placeholder="供应商旺旺" />
                                    <Button type="primary" onClick={() => this.openRelatedSupplier(relatedData, true, true)}>查询</Button>
                                </div>
                                <div style={{ marginTop: '8px', maxHeight: '600px', overflow: 'auto' }}>
                                    <table className="table-style01">
                                        <thead>
                                            <tr>
                                                <th>1688供应商</th>
                                                <th>操作</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                supplierPageList.length == 0 ?
                                                    <tr>
                                                        <td className="noneData" colSpan="20">
                                                            <div className="noneData-wrap">
                                                                <i className="iconfont icon-wushuju"></i>
                                                                <span className="noneData-title">暂无数据！</span>
                                                            </div>
                                                        </td>
                                                    </tr> : null
                                            }

                                            {
                                                supplierPageList.map((item, index) =>
                                                    <tr key={index}>
                                                        <td style={{ height: '20px' }}>
                                                            <span style={{ marginRight: '6px' }}>{item.SupplierLoginId}</span>
                                                            <a className="iconfont icon-wangwang" onClick={() => { window.open("https://amos.alicdn.com/getcid.aw?charset=utf-8&uid=" + item.SupplierLoginId + "&site=cnalichn") }}></a>
                                                        </td>
                                                        <td style={{ height: '20px' }}>
                                                            <span onClick={() => this.onUnbindSupplier(item.SupplierLoginId, relatedData.Code, 1)} style={{ cursor: 'pointer', color: '#ff0000' }}>取消关联</span>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className='paginationwrap' style={{ "marginBottom": "30px" }}>
                                    <Pagination
                                        onCurrentChange={this.changeCurrent.bind(this, 2)}
                                        onSizeChange={this.changePageSize.bind(this, 2)}
                                        layout="total,sizes,prev, pager, next"
                                        total={sTotal}
                                        pageSize={sPageSize}
                                        currentPage={sPageIndex}
                                        pageSizes={[10, 30, 50]}
                                    />
                                </div>
                            </ShowDrawer>

                            <ShowDrawer showModal={isShowRelatedSupplier} height={'calc(~"100vh - 132px")'} cancelDailog={this.cancelSupplierDrawer} hideBtn={true} titleName={'关联供应商'} showTitleClose={true}>
                                <div className='pelatedSupplier-warp_tip'>
                                    同个供应商只能绑定一个官方仓地址，若关联供应商时查询不到所需供应商，请先在已关联供应商中查询出该供应商并取消绑定后，再重新关联供应商
                                </div>
                                <div style={{ padding: '10px 24px', backgroundColor: "#f2f4f6", borderRadius: '6px', marginBottom: '8px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
                                        <span>仓库：</span>
                                        <span> {relatedSupplierData.Name}</span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
                                        <span>收件人：</span>
                                        <span> {relatedSupplierData.ContactorName}</span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
                                        <span>电话：</span>
                                        <span> {relatedSupplierData.ContactorPhone}</span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <span>地址：</span>
                                        <span> {`${relatedSupplierData.ProvinceName} ${relatedSupplierData.CityName} ${relatedSupplierData.AreaName} ${relatedSupplierData.TownName} ${relatedSupplierData.DetailAddress}`}</span>
                                    </div>
                                </div>
                                <div>
                                    <input style={{ width: "200px", marginRight: "12px" }} type="text" id="supplierLoginId2" placeholder="供应商旺旺" />
                                    <Button type="primary" onClick={() => this.openRelatedSupplierV2(relatedSupplierData, true, true)}>查询</Button>
                                </div>
                                <div style={{ marginTop: '8px', maxHeight: '480px', overflow: 'auto' }}>
                                    <table className="table-style01">
                                        <thead>
                                            <tr>
                                                <th style={{ width: "130px" }}>
                                                    <input type="checkbox" id="allCheck_supplier_Above" onClick={() => this.allCheckbox("above", "supplier")} />
                                                </th>
                                                <th>1688供应商</th>
                                                <th>操作</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                supplierPageList.length == 0 ?
                                                    <tr>
                                                        <td className="noneData" colSpan="20">
                                                            <div className="noneData-wrap">
                                                                <i className="iconfont icon-wushuju"></i>
                                                                <span className="noneData-title">暂无数据！</span>
                                                            </div>
                                                        </td>
                                                    </tr> : null
                                            }

                                            {
                                                supplierPageList.map((item, index) =>
                                                    <tr key={index}>
                                                        <td style={{ height: '20px' }}>
                                                            {
                                                                item.checked ?
                                                                    <input type="checkbox" checked onClick={() => this.supplierCheckbox(item)} /> :
                                                                    item.IsReation ?
                                                                        <input type="checkbox" disabled onClick={() => this.supplierCheckbox(item)} /> :
                                                                        <input type="checkbox" onClick={() => this.supplierCheckbox(item)} />
                                                            }
                                                        </td>
                                                        <td style={{ height: '20px' }}>
                                                            <span style={{ marginRight: '6px' }}>{item.SupplierLoginId}</span>
                                                            <a className="iconfont icon-wangwang" onClick={() => { window.open("https://amos.alicdn.com/getcid.aw?charset=utf-8&uid=" + item.SupplierLoginId + "&site=cnalichn") }}></a>
                                                        </td>
                                                        <td style={{ height: '20px' }}>
                                                            {
                                                                item.IsReation ?
                                                                    <span onClick={() => this.onUnbindSupplier(item.SupplierLoginId, relatedSupplierData.Code, 2)} style={{ cursor: 'pointer', color: '#ff0000' }}>取消关联</span>
                                                                    : null
                                                            }
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className='paginationwrap' style={{ "marginBottom": "30px" }}>
                                    <Pagination
                                        onCurrentChange={this.changeCurrent.bind(this, 3)}
                                        onSizeChange={this.changePageSize.bind(this, 3)}
                                        layout="total,sizes,prev, pager, next"
                                        total={sTotal}
                                        pageSize={sPageSize}
                                        currentPage={sPageIndex}
                                        pageSizes={[10, 30, 50]}
                                    />
                                </div>
                                <div className='pelatedSupplier-warp_footer'>
                                    <input type="checkbox" id="allCheck_supplier_Below" onClick={() => this.allCheckbox('below', 'supplier')} />
                                    <span>已选择 {selectSupplierList.length} 个供应商</span>
                                    <Button type="primary" onClick={() => this.batchRelationSupplier()}>关联供应商</Button>
                                </div>
                            </ShowDrawer>
                        </div>
                    </div>
                </main>
                <div className="zk-footer">
                    <input type="checkbox" id="allCheck_id_Below" onClick={() => this.allCheckbox('below', 'id')} />
                    <span>已勾选 {selectWareHouseList.length} 个地址</span>
                    <Button type="primary" onClick={() => this.batchSyncToShop()}>同步至店铺</Button>
                </div>
                <MyLoading isLoading={isLoading} isStopOperate={true} fullCenter={true} title={loadingTitle} />
                <NewUserGuide></NewUserGuide>
            </div>
        )
    }
}

export default officialReturnWarehouse;


// WEBPACK FOOTER //
// ./src/pages/officialReturnWarehouse/index.jsx